<div class="flex justify-content-end mb-4">
  <p-dropdown [options]="dataSets" [(ngModel)]="selectedDataset" placeholder="Language" optionLabel="label"
    (onChange)="onDatasetChanged($event)">
  </p-dropdown>
</div>
<p-table [value]="selectedSerData" class="" [styleClass]="'p-datatable-sm'">
  <ng-template pTemplate="header">
    <tr>
      <th>Age</th>
      <th>Expected myopic progression [D/year]</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-serRow>
    <tr>
      <td>{{ serRow.age }}</td>
      <td>{{ serRow.expectedSer | number:'1.2-2' }}</td>
    </tr>
  </ng-template>
</p-table>